import { LoginTypes } from "./actionTypes";

const initialState = {
  error: "",
  loading: false,
};

const login = (state = initialState, action: any) => {

  switch (action.type) {
    case LoginTypes.LOGIN_USER:
      state = {
        ...state,
        loading: true,
        error: "", // Clear previous error on new login attempt
      };
      break;
    case LoginTypes.LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
      };
      break;
    case LoginTypes.LOGOUT_USER:
      state = { ...state };
      break;
    case LoginTypes.LOGOUT_USER_SUCCESS:
      state = { ...state };
      break;
    case LoginTypes.API_ERROR:
      // Ensure error is always a string (not an Error object)
      const errorMessage = action.payload instanceof Error 
        ? action.payload.message 
        : typeof action.payload === 'string' 
        ? action.payload 
        : String(action.payload || 'An error occurred');
      state = { ...state, error: errorMessage, loading: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default login;
